import { createElement } from '../../util/element';
import { DialogPosition } from './dialog_position';

const LEFT = 2 << 1;
const CENTER = 2 << 2;
const RIGHT = 2 << 3;
const TOP = 2 << 4;
const MIDDLE = 2 << 5;
const BOTTOM = 2 << 6;


class DialogManager {
	
	constructor(options) {
		const { identifier, container, padding } = options;
		this.storage = new DialogPosition(identifier);
				
		this.identifier = identifier;
		this.parentContainer = container || document.documentElement;
		this.padding = padding;
		this.dialogs = {};		
	}
	
	getContainer() {
		if( this.container === undefined ) {			
			const element = createElement("div", "dialog-manager-container", document.body);		
			this.container = element;
			
			if( this.identifier ) {
				element.setAttribute("data-identifier", this.identifier);
			}
		}
		
		return this.container;
	}
	
	find( identifier ) {
		return this.dialogs[identifier];
	}

	open(dialog, initialPosition) {
		const element = dialog.element;
	
		const container = this.getContainer();
	
		// prevent opening twice
		if( !container.contains(element) ) {
			this.dialogs[dialog.identifier] = dialog;
			
			let targetElement = element;
			
			if( dialog.modal ) {
				const modalElement = createElement("div", "dialog-modal-background");
				modalElement.appendChild(element);
				targetElement = modalElement;
			}
			
			container.appendChild( targetElement );		
			
			const position = this.storage.getPosition(dialog.identifier);
			
			if( position ) {
				const { x, y, width, height } = position;
				
				// restore stored settings
				dialog.translate(x, y);
				dialog.setWidth(width);
				dialog.setHeight(height);
			} else {
				this.calculatePosition(dialog, initialPosition);
			}
		}
	}
		
	calculatePosition(dialog, position) {
		const padding = this.padding | 0;
		const rect = this.parentContainer.getBoundingClientRect(); 
				
		const elementRect = dialog.element.getBoundingClientRect();

		const xAxis = position & 0x1F;
		const yAxis = position - xAxis;

		let xPos = 0;
		let yPos = 0;

		if( xAxis === LEFT ) {
			xPos = rect.x + padding;			
		} else if( xAxis === RIGHT ) {
			xPos = rect.x + rect.width - elementRect.width - padding;
		} else {
			xPos = rect.x + ((rect.width - elementRect.width) / 2);
		}
		
		if( yAxis === TOP ) {
			yPos = rect.y + padding;
		} else if( yAxis === BOTTOM ) {
			yPos = rect.y + rect.height - elementRect.height - padding;
		} else {
			yPos = rect.y + ((rect.height - elementRect.height) / 2);
		}
		
		dialog.translate(xPos, yPos);
	}
		
	ensureTop(dialog) {
		const container = this.container;
		const element = dialog.element;
		
		const childNodes = Array.from(container.children);
		const index = childNodes.indexOf(element);
		
		if( !dialog.modal && childNodes.length > 0 && index < childNodes.length - 1 ) {
			container.removeChild(element);
			container.appendChild(element);
		}
	}
		
	close(dialog) {		
		let element = dialog.element;
		if( dialog.modal ) {
			element = element.parentElement;
		}
		
		if( this.container && this.container.contains( element ) ) {				
			this.container.removeChild( element );
		}
		
		delete this.dialogs[dialog.identifier];
	}
		
	closeAll() {
		if( this.container ) {
			document.body.removeChild(this.container);
			this.container = null;			
		}		
	}
	
	storePosition(dialog) {
		const position = dialog.getPosition();		
		this.storage.update(dialog.identifier, position);
	}
		
}

export { DialogManager }